<template>
  <div class="cert">
    <div class="background">
      <div class="bb"></div>
      <div class="logos">
        <logo :logo="logo.coco" :inputStyle="topLogoStyle" />
        <div class="split"></div>
        <logo :logo="logo.aihs" :inputStyle="topLogoStylehs" />
      </div>
      <div class="title">
        CERTIFICATE OF ACHIEVEMENT
      </div>
      <div class="content-1">
        This certificate is awarded to
      </div>
      <div class="name">
        {{ name }}
      </div>
      <div class="content-2">
        <p>
          for outstanding achievemnt in the
        </p>
        <p>
          Global Youth AI4SD Agent Competition 2025
        </p>
      </div>
      <div class="award">
        <div>{{round}}</div>
        <div class="award-content">{{award}}</div>
      </div>

      <div class="bottom">
        <div class="id">
          <span>Certificate ID: </span>
          <span>{{cid}}</span>
        </div>
        <div class="logo-bottom">
          <div>
            <logo :logo="logo.aihs" :inputStyle="bottomLogoStyle" />
            The Futurer of Intelligence
          </div>
          <div class="split"></div>
          <div>
            <logo :logo="logo.coco" :inputStyle="bottomLogoStyleCoco" />
            The  Future of Talent
          </div>
        </div>
        <div class="academic">
          <div>
            <span>
              Academic Partners:
            </span>
            <div class="alogos">
              <logo :logo="logo.thu" :inputStyle="thuStyle" />
              <logo :logo="logo.ucb" :inputStyle="ucbStyle" />
              <logo :logo="logo.stanford" :inputStyle="stfStyle" />
            </div>
          </div>
        </div>
      </div>
      <div class="seal">
        <logo :logo="logo.seal" :inputStyle="{width: '80px'}" />
      </div>
    </div>
    <div class="download">
      <my_button :value="buttonValue" @click.native="download" :disable="downloading" />
    </div>
  </div>

</template>

<script>
import html2canvas from 'html2canvas'
import Logo from '@/components/Logo.vue'
import Button from '@/components/Button.vue'
export default {
  props: ['name', 'award', 'slug', 'id'],
  components: {
    Logo,
    'my_button': Button
  },
  name: 'Certificate',
  data () {
    return {
      downloading: false
    }
  },
  methods: {
    download () {
      console.log('click download')
      this.downloading = true
      html2canvas(document.querySelector('.background'), {scale: 5}).then(canvas => {
        var link = document.createElement('a')
        link.download = 'certificate.png'
        link.href = canvas.toDataURL()
        link.click()
        this.downloading = false
      })
    }
  },
  computed: {
    buttonValue () {
      return this.downloading ? '生成中' :'下载证书'
    },
    thuStyle () {
      return {
        'width': '50px',
      }
    },
    ucbStyle () {
      return {
        'margin-top': '3px',
        'margin-left': '3px',
        'width': '45px',
      }
    },
    stfStyle () {
      return {
        'margin-top':'-4px',
        width: '59px'
      }
    },
    topLogoStyle () {
      return {
        width: '120px',
      }
    },
    topLogoStylehs () {
      return {
        width: '135px',
        'margin-bottom': '-5px'
      }
    },
    bottomLogoStyleCoco () {
      return {
        width: '90px',
        'margin-bottom': '5px'
      }
    },
    bottomLogoStyle () {
      return {
        width: '100px'
      }
    },
    logo () {
      return this.$store.state.logo
    },
    round () {
      const round = this.slug.split('-')[1]
      if (round == '1')
        return 'Screen Round'
      else
        return ''
    },
    cid () {
      return 'AI4SD25' + ('00000' + (this.id * 13197) % 9753).slice(-4)
    }
  }
}
</script>

<style scoped>
.cert {
}
.background {
  width: 850px;
  height: 600px;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: black;
  font-size: 16px;
  position: relative;
  margin-bottom: 20px;
}
.bb {
  background-image: url('/oss/images/frontpage/header-2025.png');
  background-blend-mode: lighten;
  background-size: 1000px 600px;
  background-position: bottom;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  opacity: 50%;
}

.logos {
  margin-top: 30px;
  margin-bottom: 10px;
  display: flex;
  align-items: flex-end;
  justify-content: center;
}

.title {
  font-size: 46px;
  font-weight: bold;
  margin-bottom: 60px;
}

.name {
  font-size: 32px;
  font-weight: bold;
  margin-top: 20px;
  margin-bottom: 10px;
}
.content-2, .content-2 > p, .award, .award > div {
  text-align: center;
}

.award-content {
  margin-top: 10px;
  font-size: 30px;
}

.bottom {
  margin-top: 60px;
  width: 90%;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  font-size: 14px;
}
.id, .academic {
  flex-basis: 30%;
}
.split {
  width: 1px;
  height: 60%;
  margin-left: 20px;
  margin-right: 18px;
  border-left: 1px solid black;
}
.logo-bottom {
  display: flex;
  align-items: flex-end;
  font-size: 12px;
}
.logo-bottom > .split {
  height: 40px;
}
.academic {
  display: flex;
  flex-direction: column-reverse;
  align-items: flex-end;
  font-size: 12px;
}
.alogos {
  display: flex;
}
.seal {
  position: absolute;
  top: 340px;
  right: 100px;
}
</style>